/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        this.target = this.dataset.target;
        this.slider = document.getElementById(this.target);
        this.buttons = Array.from(this.querySelectorAll('button'));

        let flkty = Flickity.data(this.slider);
        if (flkty) {
          flkty.on('change', () => this.updateArrows(flkty));
          this.updateArrows(flkty);
        }

        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            let handle = button.dataset.collection;
            [].forEach.call(this.buttons, function(el) {
              el.classList.remove('active');
            });

            button.classList.add('active');

            if (handle) {
              this.toggleCollection(handle);
            }

            event.preventDefault();
          });
        });
      }, 20);
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);

          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }
    updateArrows(flkty) {
      let slider = this.slider || document.getElementById(this.target),
        prevBtn = slider.querySelector('.flickity-prev'),
        nextBtn = slider.querySelector('.flickity-next');

      if (!prevBtn) return;

      let total = slider.querySelectorAll('.carousel__slide').length,
        isFirst = flkty.selectedIndex === 0,
        isLast = flkty.selectedIndex >= total - 1;

      prevBtn.style.opacity = isFirst ? '0' : '';
      prevBtn.style.pointerEvents = isFirst ? 'none' : '';
      nextBtn.style.opacity = isLast ? '0' : '';
      nextBtn.style.pointerEvents = isLast ? 'none' : '';
    }
    toggleCollection(handle) {
      let slider = this.slider || document.getElementById(this.target),
        products = slider.querySelectorAll(`.columns:not([data-collection*="${handle}"])`),
        active_products = slider.querySelectorAll(`[data-collection*="${handle}"]`),
        flkty = Flickity.data(slider);
      [].forEach.call(products, function(el) {
        el.classList.remove('carousel__slide');
        slider.append(el);
      });
      [].forEach.call(active_products, function(el) {
        if (el.dataset.collection === handle) {
          el.classList.add('carousel__slide');
        } else {
          el.classList.remove('carousel__slide');
          slider.append(el);
        }
      });
      flkty.insert(active_products);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
      this.updateArrows(flkty);
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
